
export default {
  name: "App",
};
